import { render } from "./Comment.vue?vue&type=template&id=7c4456b6&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=7c4456b6&scoped=true&lang=css"

import exportComponent from "D:\\project\\web\\clue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4456b6"]])

export default __exports__